// api/orderService.js
import axios from 'axios';
const token = localStorage.getItem('token');
// Access the environment variable for the API base URL
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL, 
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`, // Set the token from env
  },
});
export const orderCheckout = async (userData, userEmail) => {
  try {
    const response = await axiosInstance.post(`/api/DigitalCourseOrders/order-checkout`, userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
